import { render, staticRenderFns } from "./centerMemberEdit.vue?vue&type=template&id=4c8b1740&scoped=true&"
import script from "./centerMemberEdit.vue?vue&type=script&lang=js&"
export * from "./centerMemberEdit.vue?vue&type=script&lang=js&"
import style0 from "./centerMemberEdit.vue?vue&type=style&index=0&id=4c8b1740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b1740",
  null
  
)

export default component.exports